import React, { useCallback } from 'react';
import webCore from '@happylife-a/web-core';
import {
  Input,
  InputGroup,
  InputLeftElement,
  Icon,
  InputRightElement,
  FormControl,
} from '@chakra-ui/react';
import { theme } from '../../../theme';

export default function Variant11({ value, onChange, onKeyUp, setValue, width }) {
  const onClose = useCallback(() => {
    setValue('');
  }, [setValue]);

  const { t } = webCore.contexts.useTranslation();

  return (
    <FormControl mb={0} width={width || '200px'}>
      <InputGroup>
        <InputLeftElement cursor="pointer">
          <Icon as={theme.icons.SearchIconBlack} fill="none" w={4} h={4} />
        </InputLeftElement>

        <Input
          type="text"
          placeholder={t('Search')}
          borderRadius="md"
          borderWidth="1px"
          textAlign="left"
          _focus={{
            borderColor: 'grey.300',
            cursor: 'pointer',
          }}
          _hover={{
            borderColor: 'grey.300',
            cursor: 'pointer',
          }}
          _placeholder={{
            color: 'grey.500',
          }}
          value={value}
          onChange={onChange}
          onKeyUp={onKeyUp}
        />

        {value && (
          <InputRightElement cursor="pointer" onClick={onClose}>
            <Icon as={theme.icons.SearchCloseIconV2} fill="none" w={4} h={4} />
          </InputRightElement>
        )}
      </InputGroup>
    </FormControl>
  );
}
